import service from '@/utils/server';
const modName='/coal/transport/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'coalPlanTransportPageInfo',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'editDetails',
    method: 'post',
    data
  });
};

//运输计划关闭
export const coalTransportVehicleClose = data => {
  return service({
    url: modName + 'close',
    method: 'post',
    data
  });
};
//新增提交
export const addData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};
//查询外采计划方法
export const getCoalPlanSearch = data => {
  return service({
    url: modName + 'coalPlanPageInfo',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/coal/coalPlanTransportVehicle/api/index.js